function BeerPouring4(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={64} height={130} fill="none" id="beer-pouring-4" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M.542 2.47h63.19c.546 50.866-22.735 101.7-11.818 125.233A2.313 2.313 0 0149.61 130H14.664a2.311 2.311 0 01-2.302-2.297C23.279 104.17-.002 53.336.542 2.469z"
        fill="#C0BFBF"
      />
      <path
        d="M2.703 4.438h58.875c0 52.421-17.945 87.162-13.459 115.412H16.162C20.648 91.6 2.703 56.86 2.703 4.438z"
        fill="#D4D4D4"
      />
      <path
        d="M29.747 94.464a2.384 2.384 0 002.387 2.382c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38a2.384 2.384 0 00-2.387 2.38z"
        fill="#D4D4D4"
      />
      <path
        d="M44.102 59.911a3.124 3.124 0 003.129 3.118 3.123 3.123 0 003.128-3.118c0-1.724-1.399-3.12-3.128-3.12a3.125 3.125 0 00-3.129 3.12z"
        fill="#F8F8F8"
      />
      <path
        d="M32.137 130h17.472a2.313 2.313 0 002.305-2.297c-2.08-4.482-2.92-9.952-2.917-16.227.002-26.281 14.741-66.636 14.745-107.218 0-.597-.004-1.192-.01-1.789H32.137v1.968h29.437c0 52.422-17.945 87.162-13.459 115.412H32.137V130z"
        fill="#999"
      />
      <path
        d="M32.14 119.85h15.98C43.632 91.6 61.577 56.86 61.577 4.438H32.141v87.647c1.32 0 2.39 1.065 2.39 2.38a2.385 2.385 0 01-2.39 2.381v23.004zm15.096-63.062a3.123 3.123 0 013.128 3.12c0 1.723-1.399 3.12-3.128 3.12a3.124 3.124 0 01-3.129-3.12 3.125 3.125 0 013.129-3.12z"
        fill="#D4D4D4"
      />
      <path
        d="M32.134 96.846c1.32 0 2.39-1.066 2.39-2.382 0-1.314-1.07-2.38-2.39-2.38v4.762zM47.23 63.03a3.123 3.123 0 003.13-3.119c0-1.724-1.4-3.12-3.13-3.12a3.125 3.125 0 00-3.128 3.12 3.124 3.124 0 003.129 3.118z"
        fill="#D4D4D4"
      />
      <path
        d="M9.684 5.543H4.278c-.691 32.6 15.106 75.56 14.275 113.409C21.601 67.704 9.05 53.85 9.683 5.543z"
        fill="#F8F8F8"
      />
      <path
        d="M43.078 41.268c0 1.745.931 3.16 2.077 3.16 1.148 0 2.08-1.415 2.08-3.16 0-1.746-.931-3.16-2.08-3.16-1.146 0-2.077 1.414-2.077 3.16zM19.468 35.778a3.125 3.125 0 003.13 3.118 3.124 3.124 0 003.129-3.118 3.125 3.125 0 00-3.129-3.12 3.125 3.125 0 00-3.13 3.12zM20.46 25.023a4.193 4.193 0 004.2 4.186c2.32 0 4.2-1.874 4.2-4.186 0-2.311-1.88-4.187-4.2-4.187a4.195 4.195 0 00-4.2 4.187z"
        fill="#D4D4D4"
      />
      <ellipse cx={32.197} cy={3.277} rx={31.744} ry={3.277} fill="#F8F8F8" />
      <path
        d="M54.602 64.104s4.876-14.875-2.267-21.075c-2.127-1.845-7.997-.926-14.027-.01-6.168-2.517-6.915-5.873-9.947-5.988-8.303-.319-13.44 2.58-18.21 6.62-4.724 5.578.007 20.453.007 20.453h44.444z"
        fill="#F8F8F8"
      />
      <path
        d="M9.18 61.47c11.667 48.926 6.962 55.174 6.598 58.335h32.838s-.894-9.636-1.048-15.864c-.213-8.6 7.15-40.213 7.15-40.213s-16.935-.443-27.097-4.89C17.46 54.393 9.18 61.47 9.18 61.47z"
        fill="url(#prefix__paint0_linear_14338_42017)"
      />
      <path
        d="M21.973 70.126a1.129 1.129 0 100-2.258 1.129 1.129 0 000 2.258zM40.043 91.954a1.129 1.129 0 100-2.257 1.129 1.129 0 000 2.257zM41.169 73.89a1.505 1.505 0 103.01 0 1.505 1.505 0 00-3.01 0zM25.359 82.17a2.258 2.258 0 104.516 0 2.258 2.258 0 00-4.516 0zM24.988 107.762a1.13 1.13 0 100-2.258 1.13 1.13 0 000 2.258z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14338_42017"
          x1={48.697}
          y1={112.835}
          x2={15.578}
          y2={112.835}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAAF3F" />
          <stop offset={1} stopColor="#F89730" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default BeerPouring4;
